import React from 'react';
import { multiTariffHighlightMobile } from 'reactApp/appHelpers/featuresHelpers/features/multiTariffMobile';
import { Container } from 'reactApp/sections/QuotaLanding/Container/Container';
import { TabMenu } from 'reactApp/ui/Menu/TabMenu';
import { ETabMenuMod } from 'reactApp/ui/Menu/TabMenu.types';
import { TabMenuItem } from 'reactApp/ui/Menu/TabMenuItem';
import type { ETabsName } from 'reactApp/ui/TariffSectionNew/TariffSection.constants';

interface DefaultTabsProps {
    tabOptions: {
        value: ETabsName;
        text: string;
    }[];
    activeTariffTab?: ETabsName;
    onChangeTab: (value: ETabsName) => void;
}

export function DefaultTabs({ tabOptions, activeTariffTab, onChangeTab }: DefaultTabsProps) {
    return (
        <Container isNarrow isMobile>
            <TabMenu mod={multiTariffHighlightMobile ? ETabMenuMod.multiTariffHighlightMobile : ETabMenuMod.multiTariffMobile}>
                {tabOptions.map(({ value, text }) => (
                    <TabMenuItem
                        key={value}
                        name={text}
                        value={value}
                        active={value === activeTariffTab}
                        onClick={() => onChangeTab(value)}
                        changeHash={false}
                    />
                ))}
            </TabMenu>
        </Container>
    );
}
